import React from 'react'
import { Box, TextField, InputAdornment, Typography } from '@mui/material'
import { TotalImport } from './TotalImport'
import { useResumenTables } from 'context/ResumenTablesContext'

const HeaderResumen = () => {
  const {
    formatNumber,
    numeroDivision,
    setNumeroDivision,
    handleBlur,
    totalImporte
  } = useResumenTables()

  return (
    <Box display="flex" justifyContent="space-between" mb={2}>
      <TotalImport totalImporte={formatNumber(totalImporte)} />
      <Box display="flex" alignItems="center">
        <Typography sx={{ mr: 1, fontSize: '11px', fontWeight: 'bold' }}>
          Superficie edificable:
        </Typography>
        <TextField
          type="number"
          value={numeroDivision}
          onChange={e => setNumeroDivision(Number(e.target.value))}
          onBlur={handleBlur}
          InputProps={{
            endAdornment: <InputAdornment position="end">m²</InputAdornment>,
          }}
          variant="outlined"
          size="small"
          sx={{ width: 120, fontSize: 14, textAlign: 'center' }}
        />
      </Box>
    </Box>
  )
}

export default HeaderResumen
